import { Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogModule, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { CostGroup, CostGroupType, Invoice, InvoiceCategory } from '@eadsysteme/billingclient-v1';
import InvoiceComponent from './invoice.component';
import { InvoiceDetailService } from './invoice-detail.service';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { TranslocoDirective } from '@jsverse/transloco';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';

export interface InvoiceDialogData {
	selectedInvoice: Invoice;
	invoiceCategory: InvoiceCategory;
	billingId: string;
	costGroup: CostGroup;
	periodId: string;
	costGroupType: CostGroupType;
}

@Component({
	selector: 'vex-invoice-dialog',
	imports: [MatDialogModule, MatDialogTitle, MatDialogContent, InvoiceComponent, MatIcon, MatIconButton, TranslocoDirective, CdkDrag, CdkDragHandle],
	template: `
		<div class="relative" *transloco="let t">
			<button class="absolute right-2 top-2 z-10" mat-icon-button (click)="onClose()" [attr.aria-label]="t('commonActions.close')">
				<mat-icon>close</mat-icon>
			</button>
			<h2 mat-dialog-title cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">
				{{ data.selectedInvoice?.exportId ? t('billing.invoice.editTitle') : t('billing.invoice.title') }}
			</h2>

			<mat-dialog-content>
				<vex-invoice
					[selectedInvoice]="data.selectedInvoice"
					[selectedInvoiceCategory]="data.invoiceCategory"
					[billingId]="data.billingId"
					[costGroup]="data.costGroup"
					[periodId]="data.periodId"
					[costGroupType]="data.costGroupType"
					[hideAll]="hideAll"
					[dialogMode]="true"></vex-invoice>
			</mat-dialog-content>
		</div>
	`,
	changeDetection: ChangeDetectionStrategy.Eager,
	styles: [
		`
			:host {
				display: block;
				min-width: 600px;
				max-width: 95vw;
			}
		`,
	],
})
export class InvoiceDialogComponent {
	private readonly dialogRef = inject(MatDialogRef<InvoiceDialogComponent>);
	private readonly invoiceDetailService = inject(InvoiceDetailService);
	data: InvoiceDialogData = inject(MAT_DIALOG_DATA);
	hideAll = signal(false);

	constructor() {
		this.invoiceDetailService.showDetail$.subscribe((show) => {
			if (!show) {
				this.dialogRef.close(true);
			}
		});
	}

	onClose(): void {
		this.dialogRef.close(false);
	}
}
